/**
 * @link https://mui.com/material-ui/react-rating/
 */

import {
  Stack,
  Rating,
  Typography
} from "@mui/material";
import React from "react";
import ShowCode from "../../helpers/ShowCode.js";

export default function FactureeRating() {
  return (
    <>
      <Typography component="legend">Active:</Typography>
      <Stack spacing={1}>
        <Rating name="half-rating" defaultValue={2.5} precision={0.5} />
      </Stack>
      <br/>

      <Typography component="legend">Readonly:</Typography>
      <Stack spacing={1}>
        <Rating name="half-rating-read" defaultValue={3.5} precision={0.5} readOnly />
      </Stack>
      <br/>
      <br/>
      
      <ShowCode 
        codeString={`<>
  {/* Basic Rating */}
  <Typography component="legend">Basic Rating:</Typography>
  <Rating name="simple-rating" defaultValue={3} />
  
  {/* Half-star precision Rating */}
  <Typography component="legend">Half-star precision:</Typography>
  <Rating name="half-rating" defaultValue={2.5} precision={0.5} />
  
  {/* Readonly Rating */}
  <Typography component="legend">Read only:</Typography>
  <Rating name="read-only-rating" value={4} readOnly />
  
  {/* Disabled Rating */}
  <Typography component="legend">Disabled:</Typography>
  <Rating name="disabled-rating" value={3} disabled />
  
  {/* No rating (placeholder) */}
  <Typography component="legend">No rating given:</Typography>
  <Rating name="no-value-rating" value={null} />
</>`} 
        scope={{ 
          React, 
          Stack, 
          Rating, 
          Typography 
        }} 
      />
    </>
  )
}